export function DemosPage() {
  return (
    <div className="max-w-4xl">
      <h1 className="text-foreground mb-8 font-[--font-heading] text-3xl font-bold">
        ⊹ Cheeky Demos
      </h1>
      <div className="border-border bg-card rounded-lg border p-6 shadow-[--shadow]">
        <p className="text-card-foreground">
          This section will contain fun and experimental demos.
        </p>
      </div>
    </div>
  );
}

export default DemosPage;
